import kebabCase from 'lodash-es/kebabCase';

/**
 *
 * @param schoolTitle
 * @returns slug
 * @description Takes the School title and returns the slug. There is a special case for the Programming and Development school, which is just `programming`.
 */
export function toSchoolSlug(schoolTitle: string) {
  const slug = kebabCase(schoolTitle.replace(/school of /i, ''));
  if (slug === 'programming-and-development') return 'programming';
  return slug;
}
